import { render } from "./JobPostView.vue?vue&type=template&id=b22a8b6a&scoped=true"
import script from "./JobPostView.vue?vue&type=script&lang=js"
export * from "./JobPostView.vue?vue&type=script&lang=js"

import "./JobPostView.vue?vue&type=style&index=0&id=b22a8b6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b22a8b6a"]])

export default __exports__